import { LANDLORD_STATUS } from '@rental-manager/constants/OnboardingConstants';

interface GetAccountInfoInterface {
  landlordStatus: string;
  accountInfo: {
    paymentType: string;
    checkingAccountNumber: string;
    cardBrand: string;
    cardLast4: string;
  };
  accountInfoFromBackend: {
    accountName: string;
    accountType: string;
    accountLast4: string;
    cardLast4: string;
  };
}

export const getAccountLast4 = ({
  landlordStatus,
  accountInfo = {
    paymentType: '',
    checkingAccountNumber: '',
    cardBrand: '',
    cardLast4: '',
  },
  accountInfoFromBackend = {
    accountName: '',
    accountType: '',
    accountLast4: '',
    cardLast4: '',
  },
}: GetAccountInfoInterface): string => {
  let account = accountInfoFromBackend.accountName;
  let last4 = accountInfoFromBackend.accountLast4;
  if (landlordStatus === LANDLORD_STATUS.NOT_STARTED) {
    if (accountInfo.paymentType === 'bankAccount') {
      account = 'Account';
      last4 = accountInfo.checkingAccountNumber.slice(-4);
    } else if (accountInfo.paymentType === 'debit') {
      account = accountInfo.cardBrand;
      last4 = accountInfo.cardLast4;
    }
  } else {
    if (accountInfoFromBackend.accountType === 'debit') {
      last4 = accountInfoFromBackend.cardLast4;
    }
  }
  return `${account} ending in ${last4}`;
};
